setTimeout(function () {
  $(document).ready(function () {
    $("select[name=how_many_1]").change(function () {
      var selectedCountry = $(this).children("option:selected").val();
      console.log(selectedCountry);
      if (selectedCountry == 2) {
        $(".HowMany").css("display", "block");
        $(".FirstName1").css("display", "block");
        $(".Dob1").css("display", "block");
        $(".FirstName2").css("display", "block");
        $(".Dob2").css("display", "block");
        $("[name='first_name_2']").attr("required", true);
        $(".FirstName3").css("display", "none");
        $(".Dob3").css("display", "none");
      } else if (selectedCountry == 3) {
        $(".HowMany").css("display", "block");
        $(".FirstName1").css("display", "block");
        $(".Dob1").css("display", "block");
        $(".FirstName2").css("display", "block");
        $(".Dob2").css("display", "block");
        $(".FirstName3").css("display", "block");
        $(".Dob3").css("display", "block");
        $("[name='first_name_2']").attr("required", true);
        $("[name='first_name_3']").attr("required", true);
      } else {
        $(".HowMany").css("display", "block");
        $(".FirstName1").css("display", "block");
        $(".Dob1").css("display", "block");
        $(".FirstName2").css("display", "none");
        $(".Dob2").css("display", "none");
        $(".FirstName3").css("display", "none");
        $(".Dob3").css("display", "none");
      }
    });
  });
  $(".search-custom").on("click", function () {
    console.log("in");
    $("#AutoFocusMe").trigger("click");
  });

  $('input[name="i_have_children"]').click(function () {
    var selectedCountry = [];

    $.each(
      $("select[name=how_many_1]").children("option:selected"),
      function () {
        selectedCountry.push($(this).val());
      }
    );

    if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == ""
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "none");
      $(".Dob2").css("display", "none");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 1
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "none");
      $(".Dob2").css("display", "none");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 2
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "block");
      $(".Dob2").css("display", "block");
      $("[name='first_name_2']").addAttr("required");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 3
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "block");
      $(".Dob2").css("display", "block");
      $(".FirstName3").css("display", "block");
      $(".Dob3").css("display", "block");
      $("[name='first_name_2']").addeAttr("required");
      $("[name='first_name_3']").addAttr("required");
    } else if ($(this).is(":not(:checked)")) {
      $(".HowMany").css("display", "none");
      $(".FirstName1").css("display", "none");
      $(".Dob1").css("display", "none");
      $(".FirstName2").css("display", "none");
      $(".Dob2").css("display", "none");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    }
  });
}, 500);

function showCm() {
  var cmTbl = document.getElementById("cm");
  var inTbl = document.getElementById("in");
  var cmBtn = document.getElementById("cm_btn");
  var inBtn = document.getElementById("in_btn");
  if (cmTbl.style.display === "none") {
    cmTbl.style.display = "block";
    inTbl.style.display = "none";
  }
  if (cmBtn.style.backgroundColor === "unset") {
    cmBtn.style.backgroundColor = "#f9d3c9";
    inBtn.style.backgroundColor = "unset";
  }
}
function showIn() {
  var cmTbl = document.getElementById("cm");
  var inTbl = document.getElementById("in");
  var cmBtn = document.getElementById("cm_btn");
  var inBtn = document.getElementById("in_btn");
  if (inTbl.style.display === "none") {
    inTbl.style.display = "block";
    cmTbl.style.display = "none";
  }
  if (inBtn.style.backgroundColor === "unset") {
    inBtn.style.backgroundColor = "#f9d3c9";
    cmBtn.style.backgroundColor = "unset";
  }
}

$(".size-table-btn").click(function (e) {
  event.preventDefault();
});

if (window.location.href.indexOf("?view=edit#children") > -1) {
  var myInterval;
  function intrevalLoop() {
    var selectedCountry = [];

    $.each(
      $("select[name=how_many_1]").children("option:selected"),
      function () {
        selectedCountry.push($(this).val());
      }
    );

    if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == ""
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "none");
      $(".Dob2").css("display", "none");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 1
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "none");
      $(".Dob2").css("display", "none");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 2
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "block");
      $(".Dob2").css("display", "block");
      $("[name='first_name_2']").attr("required", true);
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 3
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "block");
      $(".Dob2").css("display", "block");
      $(".FirstName3").css("display", "block");
      $(".Dob3").css("display", "block");
      $("[name='first_name_2']").attr("required", true);
      $("[name='first_name_3']").attr("required", true);
    }

    if ($("div").hasClass("ChildDetails")) {
      var $container = $("html,body");
      var $scrollTo = $(".ChildDetails");
      $container.animate(
        {
          scrollTop:
            $scrollTo.offset().top -
            $container.offset().top +
            $container.scrollTop() -
            180,
          scrollLeft: 0,
        },
        1
      );
      //       $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 180, scrollLeft: 0});
      clearInterval(myInterval);
    }
  }
  myInterval = setInterval(function () {
    intrevalLoop();
  }, 100);
}

if (window.location.href.indexOf("?view=edit#personal") > -1) {
  var myInterval;
  function intrevalLoop() {
    var selectedCountry = [];

    $.each(
      $("select[name=how_many_1]").children("option:selected"),
      function () {
        selectedCountry.push($(this).val());
      }
    );

    if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == ""
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "none");
      $(".Dob2").css("display", "none");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 1
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "none");
      $(".Dob2").css("display", "none");
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 2
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "block");
      $(".Dob2").css("display", "block");
      $("[name='first_name_2']").attr("required", true);
      $(".FirstName3").css("display", "none");
      $(".Dob3").css("display", "none");
    } else if (
      $('input[name="i_have_children"]').is(":checked") &&
      selectedCountry == 3
    ) {
      $(".HowMany").css("display", "block");
      $(".FirstName1").css("display", "block");
      $(".Dob1").css("display", "block");
      $(".FirstName2").css("display", "block");
      $(".Dob2").css("display", "block");
      $(".FirstName3").css("display", "block");
      $(".Dob3").css("display", "block");
      $("[name='first_name_2']").attr("required", true);
      $("[name='first_name_3']").attr("required", true);
    }
  }
  myInterval = setInterval(function () {
    intrevalLoop();
  }, 100);
}

$(document).ready(function () {
  $(".payment-icon[aria-labelledby='pi-apple_pay']")
    .find("path")
    .first()
    .attr("opacity", ".07");

  $(document).on("click", ".ProductCard-close", function () {
    $(
      ".popup-size-custom , .popup-size-main ,.popup-size-custom-pro"
    ).removeClass("pop-open");
    $("body").removeClass("pop-open-pro");
    $(".HorizontalList__Item-checkbox  input:checkbox").prop("checked", false);
    $(".popup-size-custom , .popup-size-custom-pro").css("display", "none");
  });

  $(document).on("click", ".SizeSwatch__checkbox", function () {
    $(".error-msg").css("display", "none");
    $(".select-error-msg").css("display", "none");
  });

  // open popup start
  $(document).on("click", ".swym-btn-custom", function () {
    $(".popup-size-custom ,.popup-size-main").removeClass("pop-open");
    $(".HorizontalList__Item-checkbox  input:checkbox").prop("checked", false);
    jQuery(this)
      .parents(".ProductItem__Wrapper")
      .find(".popup-size-custom ,.popup-size-main")
      .addClass("pop-open");
    $(".popup-size-custom").css("display", "none");
    jQuery(this)
      .parents(".ProductItem__Wrapper")
      .find(".popup-size-custom")
      .css("display", "block");
  });
  // open popup close

  // item add to cart start
  $(document).on("click", ".coll__AddToCart", function () {
    data = [];
    $("input[class=SizeSwatch__checkbox]").each(function () {
      if (this.checked) {
        var coll_q = $(this).val();
        var variant_id = $(this).attr("data-id");
        data.push({ id: variant_id, quantity: 1 });
      }
    });
    addItemToCart(data, 1);
  });

  function addItemToCart(data) {
    if (!data) return;
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: data,
      },
      dataType: "json",
      success: function (response) {
        $(
          ".popup-size-custom ,.popup-size-main , .popup-size-custom-pro"
        ).removeClass("pop-open");
        $("body").removeClass("pop-open-pro");
        $(".popup-size-custom ,.popup-size-custom-pro").css("display", "none");
        document.documentElement.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: data.id,
              quantity: 1,
            },
          })
        );
      },
      error: function (error) {
        if (error.status == 422) {
          $(".error-msg").css("display", "block");
          setTimeout(function () {
            $(".error-msg").fadeOut(1500);
          }, 1000);
          $(".coll.ProductForm__Error").html(error.responseJSON.description);
        } else {
          $(".select-error-msg").css("display", "block");
        }
      },
    });
  }
  // item add to cart end

  $(".close-btn").click(function () {
    $(".custom-model-main").removeClass("model-open");
  });

  // fetch wishlist item start
  var wishlistButton = document.querySelector(".coll__wishlist");
  function swymCallbackFn() {
    _swat.fetch(function (wishlist_data) {
      $(".custom-wishlist-add").each(function () {
        var all_pro_id = parseInt($(this).attr("data-proid"));
        let swat_list_obj = wishlist_data.find((o) => o.empi === all_pro_id);

        if (swat_list_obj) {
          $(this).find(".swym-btn-custom").css("display", "none");
          $(this).find(".add-size-btn").css("display", "block");
        } else {
          $(this).find(".swym-btn-custom").css("display", "block");
          $(this).find(".add-size-btn").css("display", "none");
        }
      });

      $(".SizeSwatchList input[class=SizeSwatch__Radio]").each(function () {
        var select_var_id = parseInt($(this).attr("data-var-id"));
        let swat_list = wishlist_data.find((o) => o.epi === select_var_id);
        if (swat_list) {
          $(this).parent(".HorizontalList__Item").addClass("add-wishlist");
          if (this.checked) {
            $(".custom-wish-pro").addClass("added");
          }
        }
      });

      $(".SizeSwatchList .HorizontalList__Item").change(function () {
        var all_var_id = parseInt($(this).find("input").attr("data-var-id"));
        let swat_list_object = wishlist_data.find((o) => o.epi === all_var_id);
        if ($(this).hasClass("add-wishlist")) {
          $(this)
            .find("input[class=SizeSwatch__Radio]:checked")
            .parent(".HorizontalList__Item")
            .addClass("add-wishlist");
          $(".custom-wish-pro").addClass("added");
        } else {
          console.log("data nathi");
          $(this)
            .find("input[class=SizeSwatch__Radio]:checked")
            .parent(".HorizontalList__Item")
            .removeClass("add-wishlist");
          $(".custom-wish-pro").removeClass("added");
        }
      });
    });
    // fetch wishlist item end

    // remove wishlist on collection code start
    $(document).on("click", ".add-size-btn", function () {
      var coll_btn_val = $(this)
        .parents(".ProductItem__Wrapper")
        .find(".swym-btn-custom");
      var coll_btnadd_val = $(this)
        .parents(".ProductItem__Wrapper")
        .find(".add-size-btn");
      $(coll_btn_val).css("display", "block");
      $(coll_btnadd_val).css("display", "none");

      var product_id_wish = $(this)
        .parents(".custom-wishlist-add")
        .attr("data-proid");
      var variant_id_wish = $(this)
        .parents(".ProductItem__Wrapper")
        .find("input[class=SizeSwatch__checkbox]");
      $(variant_id_wish).each(function () {
        var variant_id_check = $(this).attr("data-id");
        window._swat.removeFromWishList(
          {
            epi: parseInt(variant_id_check),
            empi: parseInt(product_id_wish),
          },
          function (r) {}
        );
      });
    });
    // remove wishlist on collection code end

    // remove wishlist on product code start
    $(document).on("click", ".custom-wish-pro.added", function () {
      $(".custom-wish-pro").removeClass("added");
      $(".SizeSwatchList").each(function () {
        var variant_id_check = $(this)
          .find("input[class=SizeSwatch__Radio]:checked")
          .attr("data-var-id");
        var pro_id_check = $(this)
          .find("input[class=SizeSwatch__Radio]:checked")
          .attr("data-prod-id");
        $(this)
          .find("input[class=SizeSwatch__Radio]:checked")
          .parent(".HorizontalList__Item")
          .removeClass("add-wishlist");
        window._swat.removeFromWishList(
          {
            epi: parseInt(variant_id_check),
            empi: parseInt(pro_id_check),
          },
          function (r) {}
        );
      });
    });

    // remove wishlist on product code end

    $(document).on("click", ".coll__wishlist", function () {
      fetchCallbackFn();
      var check = $(this)
        .parents(".popup-size-custom , .popup-size-custom-pro")
        .find(".SizeSwatchList-custom");
      var checkval = $(check).find(
        "input[class=SizeSwatch__checkbox]:checked"
      ).length;
      var change_val = $(this)
        .parents(".ProductItem__Wrapper")
        .find(".swym-btn-custom");
      var add_val = $(this)
        .parents(".ProductItem__Wrapper")
        .find(".add-size-btn");
      var each_check = $(this).parents(".custom-wishlist-add");
      var each_check_id = $(this)
        .parents(".custom-wishlist-add")
        .attr("data-proid");
      var each_check_pro_img = $(this)
        .parents(".custom-wishlist-add")
        .attr("data-pro-img");
      var each_check_pro_title = $(this)
        .parents(".custom-wishlist-add")
        .attr("data-pro-title");
      var per_check_pro_img = $(".popup-size-main").attr("data-pro-img");
      var per_check_pro_title = $(".popup-size-main").attr("data-pro-title");

      if (checkval > 0) {
        $(change_val).css("display", "none");
        $(add_val).css("display", "block");
        $(".success-pro-title").html(each_check_pro_title);
        $(".pro-img-add").attr("src", each_check_pro_img);
        $(".success-pro-title").html(per_check_pro_title);
        $(".pro-img-add").attr("src", per_check_pro_img);
        $(".success_msg b").text(checkval);
        $(".select-error-msg").css("display", "none");
      } else {
        $(".select-error-msg").css("display", "block");
        $(change_val).css("display", "block");
        $(add_val).css("display", "none");
      }
    });

    // start code for product variant wishlist
    $(document).on(
      "click",
      ".collection_wishlist .coll__wishlist",
      function () {
        var notes_popup = document.querySelectorAll(
          "input[class=SizeSwatch__checkbox]"
        );
        var idArr_popup = [];
        notes_popup.forEach((note_popup) => {
          if (note_popup.checked) {
            var variant_id_popup = note_popup.getAttribute("data-id");
            idArr_popup.push(variant_id_popup);
          }
        });

        $(".SizeSwatchList input[class=SizeSwatch__Radio]").each(function () {
          var select_var_id_pro = $(this).attr("data-var-id");
          console.log(select_var_id_pro);
          console.log(idArr_popup);
          if ($.inArray(select_var_id_pro, idArr_popup) != -1) {
            $(this).parent(".HorizontalList__Item").addClass("add-wishlist");
            if (this.checked) {
              $(".custom-wish-pro").addClass("added");
            }
          }
        });
      }
    );
    // end code for product variant wishlist
  }

  // add to wishlist start
  function fetchCallbackFn() {
    var notes = document.querySelectorAll("input[class=SizeSwatch__checkbox]");
    var idArr = [];
    notes.forEach((note) => {
      if (note.checked) {
        var variant_id = note.getAttribute("data-id");
        var variant_title = note.getAttribute("data-title");
        idArr.push(variant_title);
        var product_id = note.getAttribute("data-proid");
        var obj = {
          [variant_title]: parseInt(variant_id),
        };
        _swat.addToWishList(
          {
            epi: parseInt(variant_id),
            empi: parseInt(product_id),
            variants: [obj],
          },

          function (r) {
            var get_var_t = idArr.join(", ");
            $(".var-title").html(get_var_t);
            $(".custom-model-main").addClass("model-open");
            $(".custom-model-main.model-open").css("display", "block");
            setTimeout(function () {
              $(".custom-model-main").fadeOut(1500);
            }, 1000);
            $(
              ".popup-size-custom ,.popup-size-main ,.popup-size-custom-pro"
            ).removeClass("pop-open");
            $("body").removeClass("pop-open-pro");
            $(".popup-size-custom , .popup-size-custom-pro").css(
              "display",
              "none"
            );
            $(".select-error-msg").css("display", "none");
          },
          function (e) {
            console.log(e);
          }
        );
      }
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  // add to wishlist end
});
$(".xsblock").click(function () {
  $(".xsblock").removeClass("current");
  $(this).addClass("current");
});

$(".xsblock.fullwidthimg").click(function () {
  $(".ProductListWrapper").addClass("current-width");
});
$(".xsblock.halfwidthimg").click(function () {
  $(".ProductListWrapper").removeClass("current-width");
});

$(".xsblock").click(function () {
  var texts = $(this).attr("id");
  localStorage.setItem("favourited", texts);
  localStorage.getItem("favourited");
  // $(".xsblock").removeClass("current");
  // $(this).addClass("current");
});
$(".xsblock.fullwidthimg").click(function () {
  $(".ProductListWrapper").addClass("current-width");
});
$(".xsblock.halfwidthimg").click(function () {
  $(".ProductListWrapper").removeClass("current-width");
});

$(document).ready(function () {
  var storage_val = localStorage.getItem("favourited");
  if (storage_val) {
    $(".xsblock").each(function () {
      var blockId = $(this).attr("id");
      if (storage_val == blockId) {
        $(this).addClass("current").siblings().removeClass("current");
      }
      if ($(".xsblock.fullwidthimg").hasClass("current")) {
        $(".ProductListWrapper").addClass("current-width");
      } else {
        $(".ProductListWrapper").removeClass("current-width");
      }
    });
  }

  $(".button-order, .button-wishlist").click(function () {
    $(".pageheader-account").css("display", "block");
    $(".pageheader-address").css("display", "none");
  });

  if (!$(this).hasClass("added")) {
    var toTop = $(".custom-wish-pro");
    toTop.on("click", function () {
      $("html, body").animate({
        scrollTop: $("html, body").offset().top,
      });
    });
  }

  $(".popup-size-custom-pro").css("display", "none");
  $(".popup-size-custom-pro").removeClass("pop-open");
  $("body").removeClass("pop-open-pro");
  $(".swym-add-to-wishlist-view-product").click(function (e) {
    event.preventDefault();
    if (!$(this).hasClass("added")) {
      $(".popup-size-custom-pro ,.popup-size-main").addClass("pop-open");
      $("body").addClass("pop-open-pro");
      $(".popup-size-custom-pro").css("display", "block");
      $(".HorizontalList__Item-checkbox  input:checkbox").prop(
        "checked",
        false
      );
    }
  });

  $(document).on("click", "#search-custom", function () {
    // document.getElementById("AutoFocusMe").focus();
    $("#AutoFocus").focus();
  });

  const handlePopupDisplay = () => {
    // Check if the script is running inside the Shopify theme editor
    const isThemeEditor = window.Shopify && window.Shopify.designMode;

    // Only run the popup logic if not in theme editor mode
    if (!isThemeEditor) {
      const hasSeenPopup = sessionStorage.getItem('hasSeenPopup');

      if (!hasSeenPopup) {
        $('#popup-anniversary-box').css('display', 'block');
        // $("body").css("overflow", "hidden");

        sessionStorage.setItem('hasSeenPopup', 'true');
      } else {
        $('#small-anniversary-box').css('display', 'block');
        // $("body").css("overflow", "visible");
      }
    } else {
      $('#popup-anniversary-box').css('display', 'block');
    }
  };

  // Execute the function to handle popup display on page load
  handlePopupDisplay();

  // Attach the same function to the shopify:section:load event
  document.addEventListener("shopify:section:load", handlePopupDisplay);

  // Close button logic for both popups
  $(".popup-close").on("click", function () {
    // $("body").css("overflow", "visible");
    $('#popup-anniversary-box').css('display', 'none'); // Hide main popup
    $('#small-anniversary-box').css('display', 'block'); // Show small popup
  });

  $(".small-popup").on("click", function () {
    $('.small-anniversary-box').css('display', 'none'); // Hide small popup
  });
});
